import { apiClient } from "../../../../lib/axios";

export interface Masterclass {
  id: string;
  title: string;
  description: string | null;
  instructor: string | null;
  location: string | null;
  image_url: string | null;
  starts_at: string;
  ends_at: string | null;
  capacity: number | null;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
  /** Client ids this masterclass is visible/bookable to. Empty = no client. */
  client_ids: string[];
  booking_count: number;
}

export interface UpsertMasterclassPayload {
  title: string;
  description?: string | null;
  instructor?: string | null;
  location?: string | null;
  image_url?: string | null;
  starts_at: string;
  ends_at?: string | null;
  capacity?: number | null;
  is_active?: boolean;
  display_order?: number;
  client_ids?: string[];
}

export interface MasterclassBooking {
  id: string;
  user_id: string;
  status: string;
  created_at: string;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
}

export const masterclassesApi = {
  list: () =>
    apiClient
      .get<{ data: Masterclass[] }>("/admin/masterclasses")
      .then((r) => r.data),

  create: (payload: UpsertMasterclassPayload) =>
    apiClient
      .post<{ data: Masterclass }>("/admin/masterclasses", payload)
      .then((r) => r.data),

  update: (id: string, payload: Partial<UpsertMasterclassPayload>) =>
    apiClient
      .patch<{ data: Masterclass }>(`/admin/masterclasses/${id}`, payload)
      .then((r) => r.data),

  delete: (id: string) =>
    apiClient.delete(`/admin/masterclasses/${id}`).then((r) => r.data),

  listBookings: (id: string) =>
    apiClient
      .get<{ data: MasterclassBooking[] }>(`/admin/masterclasses/${id}/bookings`)
      .then((r) => r.data),

  createUploadUrl: (payload: { filename: string; content_type: string }) =>
    apiClient
      .post<{ upload_url: string; file_url: string; key: string }>(
        "/admin/masterclasses/upload-url",
        payload,
      )
      .then((r) => r.data),
};
